import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, Tab, Tabs, Button, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { FusePageCarded } from '@fuse';
import Formsy from 'formsy-react';
import { TextFieldFormsy, FuseAnimate } from '@fuse';
import * as Actions from './store/actions';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
    pwWrapper: {
        padding: 10
    },
    spacer: {
        height: 20
    },
    roleButtons: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
    }
});

class Profile extends Component {

    onSubmit = (model) => {
        this.props.verifyUserPassword(this.props.auth.user.data.auth_id, model.password);
        this.props.history.push('/dashboard/');
    }

    getPageContent = () => {
        const classes = this.props.classes
        const auth = this.props.auth

        return (
            <div>
                <Typography variant="h3" >Welcome to University</Typography>
                <Typography variant="subtitle1" >To complete the user registration process, create your password.</Typography>
                <Formsy
                    onValidSubmit={this.onSubmit}
                >
                    <Grid container spacing={8} className={classes.gridStyle}>
                        <Grid item xs={12}>
                            <TextFieldFormsy
                                type="password"
                                name="password"
                                label="Password"
                                validations="equalsField:password-confirm"
                                validationErrors={{
                                    equalsField: 'Passwords do not match'
                                }}
                                required
                                autoComplete='new-password'
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextFieldFormsy
                                type="password"
                                name="password-confirm"
                                label="Confirm Password"
                                validations="equalsField:password"
                                validationErrors={{
                                    equalsField: 'Passwords do not match'
                                }}
                                required
                                autoComplete='new-password'
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                variant="raised"
                                color="primary"
                                aria-label="Change Password"
                            >
                                Save Password
                                </Button>
                        </Grid>
                    </Grid>
                </Formsy>
            </div>
        )

    }

    render() {
        const { auth, classes } = this.props;
        const pageContent = this.getPageContent()
        return (

            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24"><h4>Password Setup</h4></div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {pageContent}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        verifyUserPassword: Actions.verifyUserPassword
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile)));



// WEBPACK FOOTER //
// src/main/content/dashboard/UnverifiedUserPasswordForm.js